import { defaultDateTimeFormatter, TableField } from "../../../table-field";

const url: TableField = {
    key: "urlBase",
    label: "URL",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const dhAvaliacao: TableField = {
    key: "dhAvaliacao",
    label: "Data da Avaliação",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
    formatter: defaultDateTimeFormatter,
};
const metricaAnual: TableField = {
  key: "metricaAnual",
  label: "Métrica Anual",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const situacao: TableField = {
    key: "dsSituacao",
    label: "Situação",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const resultado = {
    key: "dsResultado",
    label: "Resultado",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
export const respostas: TableField = {
  key: "respostas",
  label: "Ver Respostas",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
export const detalhe: TableField = {
  key: "detalhe",
  label: "Detalhe",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const actions: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const ug: TableField = {
  key: "ug",
  label: "UG",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  formatter: (ug: { codUgSagres: string; nmSigla: string }) => ug.nmSigla,
  sortable: false,
};

export const fieldsAvaliacoes: TableField[] = [
    respostas,
    dhAvaliacao,
    url,
    metricaAnual,
    situacao,
    resultado,
    detalhe
];

export const fieldsAvaliacoesComUg: TableField[] = [
    respostas,
    ug,
    dhAvaliacao,
    url,
    situacao,
    resultado,
    detalhe
];
